import React, { useEffect, useState } from "react";
import T from "prop-types";
import styled, { css } from "styled-components/macro";
import { Link } from "react-router-dom";
import LogoSVG from "commons/images/logo.svg";
import GooseHonk1 from "commons/sounds/goose_honk_01.wav";
import GooseHonk2 from "commons/sounds/goose_honk_02.wav";
import GooseHonk3 from "commons/sounds/goose_honk_03.wav";
import GooseHonk4 from "commons/sounds/goose_honk_04.wav";
import GooseHonk5 from "commons/sounds/goose_honk_05.wav";
import { getRandomIntInRange } from "commons/util/helpers";

const logoStyle = css`
  display: inline-flex;
  align-items: center;
  width: fit-content;

  & > .logo-text {
    color: var(--primary-100);
    font-family: "Wendy One", sans-serif;
    letter-spacing: -2%;
  }

  ${({ size }) =>
    size === "small" &&
    css`
      gap: 6px;
      & > .logo-text {
        font-size: 20px;
        line-height: 24px;
      }
      & > img {
        width: 32px;
      }
    `}

  ${({ size }) =>
    size === "large" &&
    css`
      gap: 12px;
      & > .logo-text {
        font-size: 28px;
        line-height: 36px;
      }
      & > img {
        width: 40px;
      }
    `}
`;

const LinkBox = styled(Link)`
  ${logoStyle};
`;

const Box = styled.div`
  ${logoStyle};
`;

function Logo({ className, link, size = "small", withGoose = true }) {
  const [clicks, setClicks] = useState(0);

  useEffect(() => {
    const audio1 = new Audio(GooseHonk1);
    const audio2 = new Audio(GooseHonk2);
    const audio3 = new Audio(GooseHonk3);
    const audio4 = new Audio(GooseHonk4);
    const audio5 = new Audio(GooseHonk5);

    if (clicks && clicks % 3 === 0) {
      const randomInt = getRandomIntInRange(1, 5);

      switch (randomInt) {
        case 1:
          audio1.play();
          break;
        case 2:
          audio2.play();
          break;
        case 3:
          audio3.play();
          break;
        case 4:
          audio4.play();
          break;
        case 5:
          audio5.play();
          break;
      }
    }
  }, [clicks]);

  const content = (
    <>
      {withGoose && <img src={LogoSVG} alt="cookyourgoose logo" onClick={() => setClicks(c => c + 1)} />}
      <span className="logo-text">cookyourgoose</span>
    </>
  );

  return (
    <>
      {link ? (
        <LinkBox className={className} size={size} to={link}>
          {content}
        </LinkBox>
      ) : (
        <Box className={className} size={size}>
          {content}
        </Box>
      )}
    </>
  );
}

Logo.propTypes = {
  className: T.string,
  link: T.string,
  size: T.oneOf(["small", "large"]),
  withGoose: T.bool,
};

export default Logo;
